import img1 from '../images/articles/A1.jpeg';
import img2 from '../images/articles/A2.jpeg';
import img3 from '../images/articles/A3.jpeg';
import img4 from '../images/articles/A4.jpeg';

const articles = [
  {
    Image: img1,
    imgTop: true,
    Title: "Technology & Innovation",
    description: "The Role of Market Research in Shaping the Future of AI-Driven Healthcare",
  },
  {
    Image: img2,
    imgTop: false,
    Title: "Consumer Behavior & Insights",
    description: "Why Traditional Research Fails Today’s Digital Consumers",
  },
  {
    Image: img3,
    imgTop: true,
    Title: "Industry Transformation",
    description: "How Real-Time Insights Are Reshaping the Global Energy Sector",
  },
  {
    Image: img4,
    imgTop: false,
    Title: "UX, CX & Product Strategy",
    description: "From Wire Harness to App Design: Market Research Across the Automotive Supply Chain",
  },
];

export default articles;